module.exports = __webpack_public_path__ + "media/images/portugal_center/coimbra1-debb2761840f831e92ad4c84520ee984.jpg";